import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const Details = () => {
  return (
    <Box margin={{ xs: "25% 0% 10% 0%", sm: "5% 0% 2% 0%" }}>
      <Typography
        variant="h4"
        color="#317ABE"
        fontWeight={800}
        paddingBottom={"3%"}
        textAlign={"left"}
      >
        Neighbourhood Impact Program (NIP)
      </Typography>
      <Box
        width={"100%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "45%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            The Neighborhood Impact Program is a collaborative project of
            Blue-Echo Foundation and Aquatic Hub Afrique Network and as part of
            our Corporate Social Responsibility to the local communities in
            Abeokuta and other interested communities to ensure a thriving and
            self-sustaining environment.
          </Typography>

          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            The first edition was launched on the 20th of August, 2021 and it
            was a huge success judging by the fact that the communities who took
            part expressed their heartfelt gratitude for being part of the
            program. Blue-Echo Foundation will continue to collaborate with
            Aquatic Hub Afrique Network to impact communities for a thriving and
            self-sustaining environment.
          </Typography>
        </Box>
        <Box
          width={{ xs: "100%", sm: "50%" }}
          marginRight={{ xs: "0%", sm: "0%" }}
          marginTop={{ xs: "10%", sm: "0%" }}
          data-aos={"fade-up"}
        >
          <Typography
            variant={"body1"}
            fontWeight={700}
            textAlign={"left"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            The goals of the project are carefully crafted to:
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#9DCC49"
              fontWeight={500}
              variant={"h5"}
            >
              &#9784;{" "}
            </Typography>
            Encourage community inclusion in increasing fish production
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"2%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#9DCC49"
              fontWeight={500}
              variant={"h5"}
            >
              &#9784;{" "}
            </Typography>{" "}
            Increase household food fish consumption
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#9DCC49"
              fontWeight={500}
              variant={"h5"}
            >
              &#9784;{" "}
            </Typography>{" "}
            Prevent malnutrition
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#9DCC49"
              fontWeight={500}
              variant={"h5"}
            >
              &#9784;{" "}
            </Typography>{" "}
            Create employment for the unemployed in the communities
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            {" "}
            <Typography
              component={"span"}
              color="#9DCC49"
              fontWeight={500}
              variant={"h5"}
            >
              &#9784;{" "}
            </Typography>
            Create an additional source of income and
          </Typography>
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            data-aos={"fade-up"}
            paddingTop={"3%"}
            lineHeight={"1.625em"}
          >
            <Typography
              component={"span"}
              color="#9DCC49"
              fontWeight={500}
              variant={"h5"}
            >
              &#9784;{" "}
            </Typography>{" "}
            Ensure food security in the country
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Details;
